// // src/pages/Home.js
// import React, { useEffect, useState, useContext } from 'react';
// import axios from 'axios';
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   Fab,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Tooltip,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import SmartToyIcon from '@mui/icons-material/SmartToy';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import SchoolIcon from '@mui/icons-material/School';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
// import backgroundImage from '../Images/clg.png';
// import { AuthContext } from '../contexts/AuthContext';
// import Footer from '../components/Footer';
// import HomeContent from '../components/HomeContent';
// import { motion, AnimatePresence } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import CustomCursor from '../components/CustomCursor';
// import { useGSAPAnimations, useParallaxEffect, useFadeInUp } from '../hooks/useGSAPAnimations';

// gsap.registerPlugin(ScrollTrigger);

// // Animations
// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.1); }
// `;

// const fadeInScale = keyframes`
//   from { transform: scale(0.95); opacity: 0; }
//   to { transform: scale(1); opacity: 1; }
// `;

// // Styled Components
// const HeroContainer = styled(Box)(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[8],
//   overflow: 'hidden',
//   textAlign: 'center',
//   color: theme.palette.common.white,
//   background: `linear-gradient(135deg, rgba(33, 33, 33, 0.75) 0%, rgba(55, 48, 163, 0.85) 100%)`,
//   backdropFilter: 'blur(12px)',
//   animation: `${fadeInScale} 1s ease-out`,
//   width: '100%',
//   margin: '0 auto',
//   padding: theme.spacing(8, 4),
//   [theme.breakpoints.up('md')]: {
//     padding: theme.spacing(12, 8),
//   },
// }));

// const BackgroundImage = styled(Box)({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   filter: 'brightness(0.6)',
//   zIndex: -2,
//   transition: 'transform 0.5s ease',
//   willChange: 'transform',
//   '&:hover': {
//     transform: 'scale(1.05)',
//   },
// });

// const GradientOverlay = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   background: `linear-gradient(135deg, ${theme.palette.primary.dark}cc 0%, ${theme.palette.secondary.main}cc 100%)`,
//   zIndex: -1,
// }));

// const WelcomeText = styled(Typography)(({ theme }) => ({
//   fontWeight: 600,
//   fontSize: '1.25rem',
//   letterSpacing: '0.05em',
//   marginBottom: theme.spacing(2),
//   textShadow: '0 2px 6px rgba(0,0,0,0.4)',
// }));

// const MainTitle = styled(Typography)(({ theme }) => ({
//   fontWeight: 900,
//   fontSize: '3rem',
//   lineHeight: 1.1,
//   letterSpacing: '-0.02em',
//   marginBottom: theme.spacing(3),
//   [theme.breakpoints.up('md')]: {
//     fontSize: '4.5rem',
//   },
//   textShadow: '0 4px 12px rgba(0,0,0,0.5)',
// }));

// const HighlightText = styled('span')(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.secondary.light}, ${theme.palette.secondary.main})`,
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   fontWeight: 700,
//   fontSize: '1.5rem',
//   [theme.breakpoints.up('md')]: {
//     fontSize: '2.5rem',
//   },
// }));

// const Description = styled(Typography)(({ theme }) => ({
//   fontWeight: 400,
//   fontSize: '1.125rem',
//   maxWidth: 720,
//   margin: '0 auto',
//   opacity: 0.85,
//   marginBottom: theme.spacing(5),
//   textShadow: '0 1px 3px rgba(0,0,0,0.3)',
// }));

// const ExploreButton = styled(Button)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//   color: theme.palette.common.white,
//   borderRadius: 30,
//   padding: theme.spacing(1.5, 5),
//   fontSize: '1.125rem',
//   fontWeight: 700,
//   textTransform: 'none',
//   boxShadow: theme.shadows[6],
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
//     boxShadow: theme.shadows[12],
//     transform: 'scale(1.05)',
//   },
//   '&:focus-visible': {
//     outline: `2px solid ${theme.palette.secondary.light}`,
//     outlineOffset: 2,
//   },
// }));

// const StreakChip = styled(Chip)(({ theme }) => ({
//   background: `linear-gradient(135deg, #ff6b6b, #ee5a24)`,
//   color: theme.palette.common.white,
//   fontWeight: 700,
//   animation: `${pulse} 2.5s ease-in-out infinite`,
//   boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
//   fontSize: '1rem',
//   padding: theme.spacing(1, 2),
// }));

// const MessageBox = styled(Box)(({ theme }) => ({
//   background: theme.palette.background.paper,
//   borderRadius: theme.shape.borderRadius * 2,
//   padding: theme.spacing(4),
//   border: `1px solid ${theme.palette.divider}`,
//   boxShadow: theme.shadows[4],
//   maxWidth: 900,
//   margin: '2rem auto',
//   textAlign: 'center',
// }));

// const AIChatButton = styled(Fab)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//   color: theme.palette.common.white,
//   width: 72,
//   height: 72,
//   boxShadow: theme.shadows[8],
//   '&:hover': {
//     background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
//     transform: 'scale(1.1)',
//     boxShadow: theme.shadows[12],
//   },
//   transition: 'all 0.3s ease',
//   outline: 'none',
// }));

// const SpeechBubble = styled(motion.div)(({ theme }) => ({
//   background: theme.palette.background.paper,
//   color: theme.palette.primary.main,
//   padding: '14px 20px',
//   borderRadius: 24,
//   boxShadow: theme.shadows[6],
//   marginBottom: 16,
//   fontSize: 15,
//   fontWeight: 600,
//   position: 'relative',
//   backdropFilter: 'blur(12px)',
//   border: `1px solid ${theme.palette.divider}`,
//   userSelect: 'none',
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     bottom: -10,
//     left: '50%',
//     transform: 'translateX(-50%)',
//     width: 0,
//     height: 0,
//     borderLeft: '10px solid transparent',
//     borderRight: '10px solid transparent',
//     borderTop: `12px solid ${theme.palette.background.paper}`,
//   },
// }));

// const Home = () => {
//   const [message, setMessage] = useState('');
//   const [studyStreak, setStudyStreak] = useState(0);
//   const [showAIBubble, setShowAIBubble] = useState(false);
//   const { token } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const username = localStorage.getItem('username');

//   // GSAP animation refs
//   const { navRef, heroRef, contentRef } = useGSAPAnimations();
//   const parallaxRef = useParallaxEffect(0.3);
//   const fadeInRef = useFadeInUp(0.2);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowAIBubble(true);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const tl = gsap.timeline();

//     tl.from('.hero-title', {
//       y: 100,
//       opacity: 0,
//       duration: 1.2,
//       ease: 'power3.out',
//     })
//       .from(
//         '.hero-subtitle',
//         {
//           y: 50,
//           opacity: 0,
//           duration: 1,
//           ease: 'power2.out',
//         },
//         '-=0.8'
//       )
//       .from(
//         '.hero-description',
//         {
//           y: 30,
//           opacity: 0,
//           duration: 0.8,
//           ease: 'power2.out',
//         },
//         '-=0.6'
//       )
//       .from(
//         '.hero-buttons',
//         {
//           y: 20,
//           opacity: 0,
//           duration: 0.6,
//           ease: 'power2.out',
//         },
//         '-=0.4'
//       );

//     gsap.to('.floating-bg-1', {
//       y: -20,
//       duration: 3,
//       ease: 'power1.inOut',
//       yoyo: true,
//       repeat: -1,
//     });

//     gsap.to('.floating-bg-2', {
//       y: 20,
//       duration: 4,
//       ease: 'power1.inOut',
//       yoyo: true,
//       repeat: -1,
//     });

//     gsap.utils.toArray('.text-reveal').forEach((element, index) => {
//       gsap.fromTo(
//         element,
//         {
//           y: 50,
//           opacity: 0,
//         },
//         {
//           y: 0,
//           opacity: 1,
//           duration: 1,
//           delay: index * 0.1,
//           ease: 'power2.out',
//           scrollTrigger: {
//             trigger: element,
//             start: 'top 80%',
//             end: 'top 60%',
//             toggleActions: 'play none none reverse',
//           },
//         }
//       );
//     });

//     return () => {
//       ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
//     };
//   }, []);

//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API_URL}/`)
//       .then((response) => {
//         setMessage(response.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching data from backend:', error);
//       });
//   }, []);

//   useEffect(() => {
//     const fetchStreak = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/study-streak`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setStudyStreak(response.data.studyStreak);
//       } catch (error) {
//         console.error('Error fetching study streak:', error);
//       }
//     };
//     if (token) {
//       fetchStreak();
//     }
//   }, [token]);

//   return (
//     <>
//       <CustomCursor />
//       <Box
//         sx={{
//           minHeight: '100vh',
//           background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
//           position: 'relative',
//           overflow: 'hidden',
//           width: '100%',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             width: 400,
//             height: 400,
//             background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
//             top: -200,
//             right: -200,
//             borderRadius: '50%',
//             zIndex: 0,
//           },
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             width: 300,
//             height: 300,
//             background: 'radial-gradient(circle, rgba(139,92,246,0.08) 0%, transparent 70%)',
//             bottom: -150,
//             left: -150,
//             borderRadius: '50%',
//             zIndex: 0,
//           },
//         }}
//       >
//         <Box sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
//           <div ref={heroRef}>
//             <HeroContainer>
//               <BackgroundImage sx={{ backgroundImage: `url(${backgroundImage})` }} />
//               <GradientOverlay />

//               <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
//                 <WelcomeText variant="h5" className="hero-subtitle text-reveal">
//                   {username ? `Welcome back, ${username}! 👋` : 'Welcome! Please log in.'}
//                 </WelcomeText>

//                 <MainTitle variant="h1" className="hero-title">
//                   WELCOME TO SSPACE
//                   <br />
//                   <HighlightText>WARDHA Dashboard</HighlightText>
//                 </MainTitle>

//                 <Description variant="h6" className="hero-description text-reveal">
//                   Empowering students and educators with cutting-edge tools and resources for academic excellence.
//                 </Description>

//                 <Box
//                   className="hero-buttons"
//                   sx={{
//                     display: 'flex',
//                     gap: 3,
//                     justifyContent: 'center',
//                     flexWrap: 'wrap',
//                     alignItems: 'center',
//                   }}
//                 >
//                   <ExploreButton
//                     size="large"
//                     onClick={() => navigate('/dashboard')}
//                     startIcon={<AutoAwesomeIcon />}
//                     aria-label="Explore Dashboard"
//                   >
//                     Explore Now
//                   </ExploreButton>

//                   {token && (
//                     <StreakChip
//                       icon={<TrendingUpIcon />}
//                       label={`${studyStreak} day streak`}
//                       variant="filled"
//                       sx={{ fontSize: '1rem', py: 1.5, px: 2 }}
//                       aria-label="Study streak"
//                     />
//                   )}
//                 </Box>
//               </Container>
//             </HeroContainer>
//           </div>

//           <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 1 }}>
//             <MessageBox>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   color: 'text.primary',
//                   fontWeight: 500,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: 1,
//                 }}
//               >
//                 <SchoolIcon color="primary" />
//                 {message || 'Loading...'}
//               </Typography>
//             </MessageBox>
//           </motion.div>

//           <div ref={contentRef}>
//             <HomeContent />
//           </div>

//           <Footer />
//         </Box>

//         <AnimatePresence>
//           {showAIBubble && (
//             <motion.div
//               initial={{ opacity: 0, scale: 0 }}
//               animate={{ opacity: 1, scale: 1 }}
//               exit={{ opacity: 0, scale: 0 }}
//               transition={{ duration: 0.5 }}
//               style={{
//                 position: 'fixed',
//                 bottom: isMobile ? 20 : 30,
//                 right: isMobile ? 20 : 30,
//                 zIndex: 1300,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 gap: 8,
//               }}
//             >
//               <SpeechBubble
//                 initial={{ opacity: 0, y: -10 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: 0.3 }}
//                 onHoverStart={() => setShowAIBubble(true)}
//                 onHoverEnd={() => setShowAIBubble(false)}
//                 role="tooltip"
//                 aria-live="polite"
//               >
//                 Hi, I am SSPACE Bot! 🤖
//                 <br />
//                 <small>Click to chat with me!</small>
//               </SpeechBubble>

//               <Tooltip title="Open AI Chatbot" arrow>
//                 <motion.div
//                   animate={{
//                     scale: [1, 1.05, 1],
//                     boxShadow: [
//                       '0 0 0 rgba(102, 126, 234, 0)',
//                       '0 0 15px rgba(102, 126, 234, 0.6)',
//                       '0 0 0 rgba(102, 126, 234, 0)',
//                     ],
//                   }}
//                   transition={{
//                     repeat: Infinity,
//                     duration: 3,
//                     ease: 'easeInOut',
//                   }}
//                 >
//                   <AIChatButton onClick={() => navigate('/ai-chatbot')} aria-label="AI Chatbot">
//                     <SmartToyIcon sx={{ fontSize: 32 }} />
//                   </AIChatButton>
//                 </motion.div>
//               </Tooltip>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </Box>
//     </>
//   );
// };

// export default Home;

// // src/pages/Home.js
// import React, { useEffect, useState, useContext } from 'react';
// import axios from 'axios';
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   Fab,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Tooltip,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
//   Paper,
//   alpha,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import SmartToyIcon from '@mui/icons-material/SmartToy';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import SchoolIcon from '@mui/icons-material/School';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
// import StarIcon from '@mui/icons-material/Star';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import GroupIcon from '@mui/icons-material/Group';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import ChatIcon from '@mui/icons-material/Chat';
// import backgroundImage from '../Images/clg.png';
// import { AuthContext } from '../contexts/AuthContext';
// import Footer from '../components/Footer';
// import HomeContent from '../components/HomeContent';
// import { motion, AnimatePresence } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import CustomCursor from '../components/CustomCursor';
// import { useGSAPAnimations, useParallaxEffect, useFadeInUp } from '../hooks/useGSAPAnimations';

// gsap.registerPlugin(ScrollTrigger);

// // Enhanced Animations
// const float = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-15px) rotate(2deg); }
// `;

// const pulse = keyframes`
//   0%, 100% { opacity: 0.3; transform: scale(1); }
//   50% { opacity: 0.8; transform: scale(1.05); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const fadeInScale = keyframes`
//   from { transform: scale(0.9) translateY(30px); opacity: 0; }
//   to { transform: scale(1) translateY(0); opacity: 1; }
// `;

// const gradientShift = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;

// // Enhanced Styled Components
// const HeroContainer = styled(Box)(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.spacing(3),
//   boxShadow: `0 25px 60px ${alpha(theme.palette.common.black, 0.3)}`,
//   overflow: 'hidden',
//   textAlign: 'center',
//   color: theme.palette.common.white,
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.primary.dark, 0.9)} 0%, 
//     ${alpha(theme.palette.secondary.main, 0.85)} 50%,
//     ${alpha(theme.palette.primary.main, 0.9)} 100%)`,
//   backdropFilter: 'blur(20px)',
//   animation: `${fadeInScale} 1.2s cubic-bezier(0.4, 0, 0.2, 1)`,
//   width: '100%',
//   margin: '0 auto',
//   padding: theme.spacing(10, 4),
//   [theme.breakpoints.up('md')]: {
//     padding: theme.spacing(15, 8),
//   },
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: `linear-gradient(45deg, transparent 30%, ${alpha(theme.palette.common.white, 0.1)} 50%, transparent 70%)`,
//     backgroundSize: '200% 200%',
//     animation: `${shimmer} 3s ease-in-out infinite`,
//     zIndex: 1,
//   },
// }));

// const BackgroundImage = styled(Box)({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   filter: 'brightness(0.4) saturate(1.2)',
//   zIndex: -2,
//   transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'scale(1.08)',
//     filter: 'brightness(0.5) saturate(1.4)',
//   },
// });

// const GradientOverlay = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.primary.dark, 0.7)} 0%, 
//     ${alpha(theme.palette.secondary.dark, 0.8)} 50%,
//     ${alpha(theme.palette.primary.main, 0.7)} 100%)`,
//   backgroundSize: '400% 400%',
//   animation: `${gradientShift} 8s ease-in-out infinite`,
//   zIndex: -1,
// }));

// const WelcomeText = styled(Typography)(({ theme }) => ({
//   fontWeight: 500,
//   fontSize: '1.4rem',
//   letterSpacing: '0.02em',
//   marginBottom: theme.spacing(3),
//   textShadow: '0 3px 10px rgba(0,0,0,0.4)',
//   position: 'relative',
//   zIndex: 2,
//   background: `linear-gradient(45deg, ${theme.palette.common.white}, ${alpha(theme.palette.secondary.light, 0.9)})`,
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
// }));

// const MainTitle = styled(Typography)(({ theme }) => ({
//   fontWeight: 900,
//   fontSize: '3.5rem',
//   lineHeight: 1.05,
//   letterSpacing: '-0.03em',
//   marginBottom: theme.spacing(4),
//   [theme.breakpoints.up('md')]: {
//     fontSize: '5.5rem',
//   },
//   textShadow: '0 6px 20px rgba(0,0,0,0.6)',
//   position: 'relative',
//   zIndex: 2,
// }));

// const HighlightText = styled('span')(({ theme }) => ({
//   background: `linear-gradient(135deg, #FFD700, #FF6B6B, #4ECDC4)`,
//   backgroundSize: '200% 200%',
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   animation: `${gradientShift} 4s ease-in-out infinite`,
//   fontWeight: 900,
//   fontSize: '1.2em',
//   display: 'inline-block',
//   textShadow: 'none',
// }));

// const Description = styled(Typography)(({ theme }) => ({
//   fontWeight: 400,
//   fontSize: '1.3rem',
//   maxWidth: 800,
//   margin: '0 auto',
//   opacity: 0.95,
//   marginBottom: theme.spacing(6),
//   textShadow: '0 2px 8px rgba(0,0,0,0.3)',
//   lineHeight: 1.6,
//   position: 'relative',
//   zIndex: 2,
// }));

// const ExploreButton = styled(Button)(({ theme }) => ({
//   background: `linear-gradient(135deg, #FE6B8B 0%, #FF8E53 50%, #FE6B8B 100%)`,
//   backgroundSize: '200% 200%',
//   color: theme.palette.common.white,
//   borderRadius: 50,
//   padding: theme.spacing(2, 6),
//   fontSize: '1.2rem',
//   fontWeight: 700,
//   textTransform: 'none',
//   boxShadow: `0 15px 35px ${alpha('#FE6B8B', 0.4)}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&:hover': {
//     animation: `${gradientShift} 2s ease-in-out infinite`,
//     boxShadow: `0 20px 50px ${alpha('#FE6B8B', 0.6)}`,
//     transform: 'translateY(-3px) scale(1.05)',
//   },
//   '&:focus-visible': {
//     outline: `3px solid ${alpha(theme.palette.secondary.light, 0.5)}`,
//     outlineOffset: 3,
//   },
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     width: 0,
//     height: 0,
//     background: alpha(theme.palette.common.white, 0.2),
//     borderRadius: '50%',
//     transform: 'translate(-50%, -50%)',
//     transition: 'width 0.6s, height 0.6s',
//   },
//   '&:active::before': {
//     width: '300px',
//     height: '300px',
//   },
// }));

// const StreakChip = styled(Chip)(({ theme }) => ({
//   background: `linear-gradient(135deg, #ff6b6b, #ee5a24, #ff6b6b)`,
//   backgroundSize: '200% 200%',
//   color: theme.palette.common.white,
//   fontWeight: 700,
//   animation: `${pulse} 3s ease-in-out infinite, ${gradientShift} 4s ease-in-out infinite`,
//   boxShadow: `0 10px 30px ${alpha('#ff6b6b', 0.5)}`,
//   fontSize: '1.1rem',
//   padding: theme.spacing(1.5, 3),
//   borderRadius: 25,
// }));

// const EnhancedMessageBox = styled(Paper)(({ theme }) => ({
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.background.paper, 0.95)} 0%, 
//     ${alpha(theme.palette.background.default, 0.9)} 100%)`,
//   backdropFilter: 'blur(20px)',
//   borderRadius: theme.spacing(3),
//   padding: theme.spacing(6),
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//   boxShadow: `0 20px 60px ${alpha(theme.palette.primary.main, 0.15)}`,
//   maxWidth: 1000,
//   margin: '3rem auto',
//   textAlign: 'center',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: '3px',
//     background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
//     backgroundSize: '200% 100%',
//     animation: `${shimmer} 2s ease-in-out infinite`,
//   },
// }));

// const FeatureCard = styled(Card)(({ theme }) => ({
//   height: '100%',
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.background.paper, 0.95)} 0%, 
//     ${alpha(theme.palette.background.default, 0.9)} 100%)`,
//   backdropFilter: 'blur(20px)',
//   borderRadius: theme.spacing(3),
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//   boxShadow: `0 15px 35px ${alpha(theme.palette.common.black, 0.08)}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   overflow: 'hidden',
//   position: 'relative',
//   '&:hover': {
//     transform: 'translateY(-10px) scale(1.02)',
//     boxShadow: `0 25px 60px ${alpha(theme.palette.primary.main, 0.2)}`,
//     '& .feature-icon': {
//       transform: 'scale(1.1) rotate(5deg)',
//     },
//     '& .learn-more': {
//       transform: 'translateX(5px)',
//     },
//   },
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: '2px',
//     background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, transparent)`,
//     opacity: 0,
//     transition: 'opacity 0.3s ease',
//   },
//   '&:hover::before': {
//     opacity: 1,
//   },
// }));

// const AIChatButton = styled(Fab)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//   color: theme.palette.common.white,
//   width: 80,
//   height: 80,
//   boxShadow: `0 15px 40px ${alpha(theme.palette.primary.main, 0.4)}`,
//   '&:hover': {
//     background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
//     transform: 'scale(1.15)',
//     boxShadow: `0 20px 60px ${alpha(theme.palette.primary.main, 0.6)}`,
//   },
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   outline: 'none',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: -2,
//     left: -2,
//     right: -2,
//     bottom: -2,
//     background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//     borderRadius: '50%',
//     zIndex: -1,
//     opacity: 0,
//     transition: 'opacity 0.3s ease',
//   },
//   '&:hover::before': {
//     opacity: 0.3,
//   },
// }));

// const SpeechBubble = styled(motion.div)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${alpha(theme.palette.primary.light, 0.1)})`,
//   color: theme.palette.primary.main,
//   padding: '16px 24px',
//   borderRadius: 25,
//   boxShadow: `0 15px 40px ${alpha(theme.palette.primary.main, 0.2)}`,
//   marginBottom: 20,
//   fontSize: 16,
//   fontWeight: 600,
//   position: 'relative',
//   backdropFilter: 'blur(20px)',
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//   userSelect: 'none',
//   maxWidth: 280,
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     bottom: -12,
//     left: '50%',
//     transform: 'translateX(-50%)',
//     width: 0,
//     height: 0,
//     borderLeft: '12px solid transparent',
//     borderRight: '12px solid transparent',
//     borderTop: `14px solid ${theme.palette.background.paper}`,
//   },
// }));

// const FloatingElement = styled(Box)(({ theme, delay = 0 }) => ({
//   position: 'absolute',
//   borderRadius: '50%',
//   background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)}, ${alpha(theme.palette.secondary.main, 0.1)})`,
//   animation: `${float} ${3 + Math.random() * 2}s ease-in-out infinite`,
//   animationDelay: `${delay}s`,
//   zIndex: 0,
// }));

// const Home = () => {
//   const [message, setMessage] = useState('');
//   const [studyStreak, setStudyStreak] = useState(0);
//   const [showAIBubble, setShowAIBubble] = useState(false);
//   const { token } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const username = localStorage.getItem('username');
//   const subjects = localStorage.getItem('subjects');
//   const department = localStorage.getItem('department');



//   // GSAP animation refs
//   const { navRef, heroRef, contentRef } = useGSAPAnimations();
//   const parallaxRef = useParallaxEffect(0.3);
//   const fadeInRef = useFadeInUp(0.2);

//   const features = [
//     {
//       icon: <SchoolIcon fontSize="large" />,
//       title: 'Smart Learning',
//       description: 'AI-powered study materials and personalized learning paths tailored to your needs.',
//       color: theme.palette.primary.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`
//     },
//     {
//       icon: <GroupIcon fontSize="large" />,
//       title: 'Collaborative Study',
//       description: 'Connect with peers, join study groups, and learn together in real-time.',
//       color: theme.palette.secondary.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.secondary.light}, ${theme.palette.secondary.main})`
//     },
//     {
//       icon: <AssignmentIcon fontSize="large" />,
//       title: 'Progress Tracking',
//       description: 'Monitor your academic progress with detailed analytics and insights.',
//       color: theme.palette.success.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.success.light}, ${theme.palette.success.main})`
//     },
//     {
//       icon: <ChatIcon fontSize="large" />,
//       title: 'AI Assistant',
//       description: 'Get instant help with your studies from our intelligent chatbot, available 24/7.',
//       color: theme.palette.warning.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.warning.light}, ${theme.palette.warning.main})`
//     }
//   ];

//   const stats = [
//     { number: '10K+', label: 'Active Students' },
//     { number: '95%', label: 'Success Rate' },
//     { number: '24/7', label: 'AI Support' },
//     { number: '500+', label: 'Study Resources' }
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowAIBubble(true);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const tl = gsap.timeline();

//     // Enhanced hero animations
//     tl.from('.hero-welcome', {
//       y: 100,
//       opacity: 0,
//       duration: 1.2,
//       ease: 'power3.out',
//     })
//       .from('.hero-title', {
//         y: 120,
//         opacity: 0,
//         duration: 1.4,
//         ease: 'power3.out',
//       }, '-=0.8')
//       .from('.hero-description', {
//         y: 80,
//         opacity: 0,
//         duration: 1,
//         ease: 'power2.out',
//       }, '-=1')
//       .from('.hero-buttons', {
//         y: 60,
//         opacity: 0,
//         duration: 0.8,
//         ease: 'power2.out',
//       }, '-=0.6')
//       .from('.hero-stats', {
//         y: 40,
//         opacity: 0,
//         duration: 0.6,
//         stagger: 0.1,
//         ease: 'power2.out',
//       }, '-=0.4');

//     // Floating background elements
//     for (let i = 1; i <= 5; i++) {
//       gsap.to(`.floating-bg-${i}`, {
//         y: -30 - (i * 5),
//         x: Math.sin(i) * 20,
//         duration: 3 + i,
//         ease: 'power1.inOut',
//         yoyo: true,
//         repeat: -1,
//         delay: i * 0.2,
//       });
//     }

//     // Enhanced scroll animations
//     gsap.utils.toArray('.feature-card').forEach((element, index) => {
//       gsap.fromTo(element, {
//         y: 100,
//         opacity: 0,
//         scale: 0.8,
//       }, {
//         y: 0,
//         opacity: 1,
//         scale: 1,
//         duration: 1.2,
//         delay: index * 0.2,
//         ease: 'power3.out',
//         scrollTrigger: {
//           trigger: element,
//           start: 'top 85%',
//           end: 'top 60%',
//           toggleActions: 'play none none reverse',
//         },
//       });
//     });

//     return () => {
//       ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
//     };
//   }, []);

//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API_URL}/`)
//       .then((response) => {
//         setMessage(response.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching data from backend:', error);
//       });
//   }, []);

//   useEffect(() => {
//     const fetchStreak = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/study-streak`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setStudyStreak(response.data.studyStreak);
//       } catch (error) {
//         console.error('Error fetching study streak:', error);
//       }
//     };
//     if (token) {
//       fetchStreak();
//     }
//   }, [token]);

//   return (
//     <>
//       <CustomCursor />
//       <Box
//         sx={{
//           minHeight: '100vh',
//           background: `linear-gradient(135deg, 
//             ${theme.palette.background.default} 0%, 
//             ${alpha(theme.palette.primary.light, 0.05)} 50%,
//             ${alpha(theme.palette.secondary.light, 0.05)} 100%)`,
//           position: 'relative',
//           overflow: 'hidden',
//           width: '100%',
//         }}
//       >
//         {/* Enhanced Floating Elements */}
//         {[...Array(5)].map((_, i) => (
//           <FloatingElement
//             key={i}
//             className={`floating-bg-${i + 1}`}
//             delay={i * 0.5}
//             sx={{
//               width: 60 + i * 20,
//               height: 60 + i * 20,
//               top: `${10 + i * 15}%`,
//               left: `${5 + i * 20}%`,
//               right: i % 2 === 0 ? `${5 + i * 15}%` : 'auto',
//             }}
//           />
//         ))}

//         <Box sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
//           <div ref={heroRef}>
//             <Container maxWidth="lg" sx={{ pt: 4 }}>
//               <HeroContainer>
//                 <BackgroundImage sx={{ backgroundImage: `url(${backgroundImage})` }} />
//                 <GradientOverlay />

//                 <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
//                   <Chip
//                     icon={<AutoAwesomeIcon />}
//                     label="Welcome to the Future of Learning"
//                     className="hero-welcome"
//                     sx={{
//                       mb: 4,
//                       background: alpha(theme.palette.common.white, 0.2),
//                       color: 'white',
//                       backdropFilter: 'blur(10px)',
//                       fontSize: '1rem',
//                       fontWeight: 600,
//                       py: 1,
//                       px: 3,
//                     }}
//                   />

//                   <WelcomeText variant="h3" className="hero-welcome">
//                     {username ? `Welcome back, ${username}! 👋` : 'Welcome! Please log in.'}
//                   </WelcomeText>

//                   <MainTitle variant="h1" className="hero-title">
//                     SSPACE WARDHA
//                     <br />
//                     <HighlightText>Smart Dashboard</HighlightText>
//                   </MainTitle>

//                   <Description variant="h6" className="hero-description">
//                     Transform your academic journey with AI-powered learning tools, collaborative features, 
//                     and intelligent progress tracking designed for the modern student.
//                   </Description>

//                   <Box
//                     className="hero-buttons"
//                     sx={{
//                       display: 'flex',
//                       gap: 3,
//                       justifyContent: 'center',
//                       flexWrap: 'wrap',
//                       alignItems: 'center',
//                       mb: 6,
//                     }}
//                   >
//                     <ExploreButton
//                       size="large"
//                       onClick={() => navigate('/dashboard')}
//                       startIcon={<RocketLaunchIcon />}
//                       aria-label="Explore Dashboard"
//                     >
//                       Launch Dashboard
//                     </ExploreButton>

//                     {token && (
//                       <StreakChip
//                         icon={<TrendingUpIcon />}
//                         label={`${studyStreak} day streak 🔥`}
//                         variant="filled"
//                         aria-label="Study streak"
//                       />
//                     )}
//                   </Box>

//                   {/* Stats Section */}
//                   <Grid container spacing={4} className="hero-stats">
//                     {stats.map((stat, index) => (
//                       <Grid item xs={6} md={3} key={index}>
//                         <Box sx={{ textAlign: 'center' }}>
//                           <Typography
//                             variant="h3"
//                             sx={{
//                               fontWeight: 900,
//                               color: 'white',
//                               mb: 1,
//                               fontSize: { xs: '2rem', md: '2.5rem' },
//                               textShadow: '0 4px 12px rgba(0,0,0,0.4)',
//                             }}
//                           >
//                             {stat.number}
//                           </Typography>
//                           <Typography
//                             variant="body1"
//                             sx={{
//                               color: alpha(theme.palette.common.white, 0.9),
//                               fontWeight: 500,
//                               fontSize: '1.1rem',
//                             }}
//                           >
//                             {stat.label}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Container>
//               </HeroContainer>
//             </Container>
//           </div>

//           {/* Enhanced Message Box */}
//           <Container maxWidth="lg">
//             <motion.div 
//               initial={{ opacity: 0, y: 40 }} 
//               animate={{ opacity: 1, y: 0 }} 
//               transition={{ duration: 0.8, delay: 1.2 }}
//             >
//               <EnhancedMessageBox elevation={0}>
//                 <Typography
//                   variant="h5"
//                   sx={{
//                     color: 'text.primary',
//                     fontWeight: 600,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: 2,
//                     mb: 2,
//                   }}
//                 >
//                   <SchoolIcon color="primary" sx={{ fontSize: 32 }} />
//                   {message || 'Loading...'}
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     color: 'text.secondary',
//                     maxWidth: 600,
//                     mx: 'auto',
//                   }}
//                 >
//                   Experience the next generation of academic excellence with our comprehensive platform.
//                 </Typography>
//               </EnhancedMessageBox>
//             </motion.div>
//           </Container>

//           {/* Enhanced Features Section */}
//           <Container maxWidth="lg" sx={{ py: 8 }}>
//             <Box sx={{ textAlign: 'center', mb: 6 }}>
//               <Chip
//                 icon={<StarIcon />}
//                 label="Powerful Features"
//                 sx={{
//                   mb: 3,
//                   background: theme.palette.primary.main,
//                   color: 'white',
//                   fontSize: '1rem',
//                   py: 1,
//                   px: 3,
//                 }}
//               />
//               <Typography
//                 variant="h2"
//                 sx={{
//                   fontWeight: 900,
//                   color: 'text.primary',
//                   mb: 3,
//                   fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 }}
//               >
//                 Everything You Need to{' '}
//                 <Box
//                   component="span"
//                   sx={{
//                     background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                     WebkitBackgroundClip: 'text',
//                     WebkitTextFillColor: 'transparent',
//                   }}
//                 >
//                   Excel
//                 </Box>
//               </Typography>
//             </Box>

//             <Grid container spacing={4}>
//               {features.map((feature, index) => (
//                 <Grid item xs={12} sm={6} lg={3} key={index}>
//                   <FeatureCard className="feature-card" elevation={0}>
//                     <CardContent sx={{ p: 4, height: '100%' }}>
//                       <Avatar
//                         className="feature-icon"
//                         sx={{
//                           width: 80,
//                           height: 80,
//                           mb: 3,
//                           background: feature.bgGradient,
//                           boxShadow: `0 15px 35px ${alpha(feature.color, 0.3)}`,
//                           transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//                         }}
//                       >
//                         {feature.icon}
//                       </Avatar>
                      
//                       <Typography
//                         variant="h5"
//                         sx={{
//                           fontWeight: 700,
//                           mb: 2,
//                           color: 'text.primary',
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>
                      
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           color: 'text.secondary',
//                           lineHeight: 1.7,
//                           mb: 3,
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
                      
//                       <Box
//                         className="learn-more"
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           color: feature.color,
//                           fontWeight: 600,
//                           fontSize: '1rem',
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             color: theme.palette.text.primary,
//                           }
//                         }}
//                       >
//                         Explore Feature
//                         <ArrowForwardIcon sx={{ ml: 1, fontSize: '1.2rem' }} />
//                       </Box>
//                     </CardContent>
//                   </FeatureCard>
//                 </Grid>
//               ))}
//             </Grid>
//           </Container>

//           {/* Call to Action Section */}
//           <Container maxWidth="lg" sx={{ py: 8 }}>
//             <Paper
//               elevation={0}
//               sx={{
//                 background: `linear-gradient(135deg, 
//                   ${alpha(theme.palette.primary.main, 0.08)} 0%, 
//                   ${alpha(theme.palette.secondary.main, 0.08)} 100%)`,
//                 backdropFilter: 'blur(20px)',
//                 borderRadius: 4,
//                 p: { xs: 4, md: 8 },
//                 textAlign: 'center',
//                 border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&::before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   height: '100%',
//                   background: `radial-gradient(circle at 30% 20%, ${alpha(theme.palette.primary.main, 0.1)} 0%, transparent 50%)`,
//                   zIndex: 0,
//                 },
//               }}
//             >
//               <Box sx={{ position: 'relative', zIndex: 1 }}>
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 900,
//                     color: 'text.primary',
//                     mb: 3,
//                     fontSize: { xs: '2.5rem', md: '3.5rem' },
//                   }}
//                 >
//                   Ready to{' '}
//                   <Box
//                     component="span"
//                     sx={{
//                       background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent',
//                     }}
//                   >
//                     Transform
//                   </Box>{' '}
//                   Your Learning?
//                 </Typography>
                
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     color: 'text.secondary',
//                     mb: 5,
//                     maxWidth: 700,
//                     mx: 'auto',
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   Join thousands of students who have already discovered the power of smart academic management. 
//                   Start your journey towards academic excellence today.
//                 </Typography>
                
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     gap: 3,
//                     justifyContent: 'center',
//                     flexDirection: { xs: 'column', sm: 'row' },
//                     mb: 4,
//                   }}
//                 >
//                   <Button
//                     variant="contained"
//                     size="large"
//                     endIcon={<ArrowForwardIcon />}
//                     onClick={() => navigate('/login')}
//                     sx={{
//                       px: 5,
//                       py: 2,
//                       fontSize: '1.2rem',
//                       fontWeight: 700,
//                       borderRadius: 50,
//                       background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                       boxShadow: `0 15px 35px ${alpha(theme.palette.primary.main, 0.3)}`,
//                       '&:hover': {
//                         transform: 'translateY(-3px)',
//                         boxShadow: `0 20px 50px ${alpha(theme.palette.primary.main, 0.4)}`,
//                       },
//                     }}
//                   >
//                     Get Started Free
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     size="large"
//                     startIcon={<PlayArrowIcon />}
//                     sx={{
//                       px: 5,
//                       py: 2,
//                       fontSize: '1.2rem',
//                       fontWeight: 700,
//                       borderRadius: 50,
//                       borderColor: theme.palette.primary.main,
//                       color: theme.palette.primary.main,
//                       borderWidth: 2,
//                       '&:hover': {
//                         borderWidth: 2,
//                         background: alpha(theme.palette.primary.main, 0.05),
//                       },
//                     }}
//                   >
//                     Watch Demo
//                   </Button>
//                 </Box>
                
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: 'text.secondary',
//                     fontSize: '1rem',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: 1,
//                   }}
//                 >
//                   <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
//                   No credit card required • Free forever • Premium features available
//                 </Typography>
//               </Box>
//             </Paper>
//           </Container>

//           <div ref={contentRef}>
//             <HomeContent />
//           </div>

//           <Footer />
//         </Box>

//         {/* Enhanced AI Chat Button */}
//         <AnimatePresence>
//           {showAIBubble && (
//             <motion.div
//               initial={{ opacity: 0, scale: 0, y: 100 }}
//               animate={{ opacity: 1, scale: 1, y: 0 }}
//               exit={{ opacity: 0, scale: 0, y: 100 }}
//               transition={{ 
//                 duration: 0.6, 
//                 type: "spring", 
//                 stiffness: 200, 
//                 damping: 20 
//               }}
//               style={{
//                 position: 'fixed',
//                 bottom: isMobile ? 20 : 30,
//                 right: isMobile ? 20 : 30,
//                 zIndex: 1300,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 gap: 12,
//               }}
//             >
//               <SpeechBubble
//                 initial={{ opacity: 0, y: -20, scale: 0.8 }}
//                 animate={{ opacity: 1, y: 0, scale: 1 }}
//                 transition={{ duration: 0.5, delay: 0.3 }}
//                 whileHover={{ scale: 1.05 }}
//                 role="tooltip"
//                 aria-live="polite"
//               >
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Typography variant="body2" sx={{ fontWeight: 700 }}>
//                     Hi, I'm SSPACE Bot! 🤖
//                   </Typography>
//                 </Box>
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Click to start chatting with me!
//                 </Typography>
//               </SpeechBubble>

//               <Tooltip title="Open AI Chatbot" arrow placement="left">
//                 <motion.div
//                   animate={{
//                     scale: [1, 1.1, 1],
//                     rotate: [0, 5, -5, 0],
//                   }}
//                   transition={{
//                     repeat: Infinity,
//                     duration: 4,
//                     ease: 'easeInOut',
//                   }}
//                   whileHover={{ scale: 1.2 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <AIChatButton 
//                     onClick={() => navigate('/ai-chatbot')} 
//                     aria-label="AI Chatbot"
//                   >
//                     <SmartToyIcon sx={{ fontSize: 36 }} />
//                   </AIChatButton>
//                 </motion.div>
//               </Tooltip>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </Box>
//     </>
//   );
// };

// export default Home;

// // src/pages/Home.js
// import React, { useEffect, useState, useContext } from 'react';
// import axios from 'axios';
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   Fab,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Tooltip,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
//   Paper,
//   alpha,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import SmartToyIcon from '@mui/icons-material/SmartToy';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import SchoolIcon from '@mui/icons-material/School';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
// import StarIcon from '@mui/icons-material/Star';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import GroupIcon from '@mui/icons-material/Group';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import ChatIcon from '@mui/icons-material/Chat';
// import backgroundImage from '../Images/clg.png';
// import { AuthContext } from '../contexts/AuthContext';
// import Footer from '../components/Footer';
// import HomeContent from '../components/HomeContent';
// import { motion, AnimatePresence } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';
// import CustomCursor from '../components/CustomCursor';

// // Enhanced CSS-only Animations
// const float = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-15px) rotate(2deg); }
// `;

// const pulse = keyframes`
//   0%, 100% { opacity: 0.3; transform: scale(1); }
//   50% { opacity: 0.8; transform: scale(1.05); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const fadeInUp = keyframes`
//   from { transform: translateY(40px); opacity: 0; }
//   to { transform: translateY(0); opacity: 1; }
// `;

// const fadeInScale = keyframes`
//   from { transform: scale(0.9) translateY(30px); opacity: 0; }
//   to { transform: scale(1) translateY(0); opacity: 1; }
// `;

// const gradientShift = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;

// const slideInRight = keyframes`
//   from { transform: translateX(50px); opacity: 0; }
//   to { transform: translateX(0); opacity: 1; }
// `;

// const slideInLeft = keyframes`
//   from { transform: translateX(-50px); opacity: 0; }
//   to { transform: translateX(0); opacity: 1; }
// `;

// // Full Width Hero Container
// const FullWidthHeroContainer = styled(Box)(({ theme }) => ({
//   position: 'relative',
//   minHeight: '100vh',
//   width: '100vw',
//   marginLeft: 'calc(-50vw + 50%)',
//   boxShadow: `0 25px 60px ${alpha(theme.palette.common.black, 0.3)}`,
//   overflow: 'hidden',
//   display: 'flex',
//   alignItems: 'center',
//   color: theme.palette.common.white,
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.primary.dark, 0.9)} 0%, 
//     ${alpha(theme.palette.secondary.main, 0.85)} 50%,
//     ${alpha(theme.palette.primary.main, 0.9)} 100%)`,
//   backdropFilter: 'blur(20px)',
//   animation: `${fadeInScale} 1.2s cubic-bezier(0.4, 0, 0.2, 1)`,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: `linear-gradient(45deg, transparent 30%, ${alpha(theme.palette.common.white, 0.1)} 50%, transparent 70%)`,
//     backgroundSize: '200% 200%',
//     animation: `${shimmer} 3s ease-in-out infinite`,
//     zIndex: 1,
//   },
// }));

// const BackgroundImage = styled(Box)({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   backgroundAttachment: 'fixed',
//   filter: 'brightness(0.4) saturate(1.2)',
//   zIndex: -2,
//   transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     transform: 'scale(1.05)',
//     filter: 'brightness(0.5) saturate(1.4)',
//   },
// });

// const GradientOverlay = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.primary.dark, 0.7)} 0%, 
//     ${alpha(theme.palette.secondary.dark, 0.8)} 50%,
//     ${alpha(theme.palette.primary.main, 0.7)} 100%)`,
//   backgroundSize: '400% 400%',
//   animation: `${gradientShift} 8s ease-in-out infinite`,
//   zIndex: -1,
// }));

// const HeroContent = styled(Container)(({ theme }) => ({
//   position: 'relative',
//   zIndex: 2,
//   textAlign: 'center',
//   padding: theme.spacing(8, 4),
//   [theme.breakpoints.up('md')]: {
//     padding: theme.spacing(12, 8),
//   },
// }));

// const WelcomeText = styled(Typography)(({ theme }) => ({
//   fontWeight: 500,
//   fontSize: '1.4rem',
//   letterSpacing: '0.02em',
//   marginBottom: theme.spacing(3),
//   textShadow: '0 3px 10px rgba(0,0,0,0.4)',
//   background: `linear-gradient(45deg, ${theme.palette.common.white}, ${alpha(theme.palette.secondary.light, 0.9)})`,
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   animation: `${fadeInUp} 1s ease-out 0.2s both`,
// }));

// const MainTitle = styled(Typography)(({ theme }) => ({
//   fontWeight: 900,
//   fontSize: '3.5rem',
//   lineHeight: 1.05,
//   letterSpacing: '-0.03em',
//   marginBottom: theme.spacing(4),
//   [theme.breakpoints.up('md')]: {
//     fontSize: '5.5rem',
//   },
//   textShadow: '0 6px 20px rgba(0,0,0,0.6)',
//   animation: `${fadeInUp} 1.2s ease-out 0.4s both`,
// }));

// const HighlightText = styled('span')(({ theme }) => ({
//   background: `linear-gradient(135deg, #FFD700, #FF6B6B, #4ECDC4)`,
//   backgroundSize: '200% 200%',
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   animation: `${gradientShift} 4s ease-in-out infinite`,
//   fontWeight: 900,
//   fontSize: '1.2em',
//   display: 'inline-block',
//   textShadow: 'none',
// }));

// const Description = styled(Typography)(({ theme }) => ({
//   fontWeight: 400,
//   fontSize: '1.3rem',
//   maxWidth: 800,
//   margin: '0 auto',
//   opacity: 0.95,
//   marginBottom: theme.spacing(6),
//   textShadow: '0 2px 8px rgba(0,0,0,0.3)',
//   lineHeight: 1.6,
//   animation: `${fadeInUp} 1s ease-out 0.6s both`,
// }));

// const ButtonContainer = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   gap: theme.spacing(3),
//   justifyContent: 'center',
//   flexWrap: 'wrap',
//   alignItems: 'center',
//   marginBottom: theme.spacing(6),
//   animation: `${fadeInUp} 1s ease-out 0.8s both`,
// }));

// const ExploreButton = styled(Button)(({ theme }) => ({
//   background: `linear-gradient(135deg, #FE6B8B 0%, #FF8E53 50%, #FE6B8B 100%)`,
//   backgroundSize: '200% 200%',
//   color: theme.palette.common.white,
//   borderRadius: 50,
//   padding: theme.spacing(2, 6),
//   fontSize: '1.2rem',
//   fontWeight: 700,
//   textTransform: 'none',
//   boxShadow: `0 15px 35px ${alpha('#FE6B8B', 0.4)}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&:hover': {
//     animation: `${gradientShift} 2s ease-in-out infinite`,
//     boxShadow: `0 20px 50px ${alpha('#FE6B8B', 0.6)}`,
//     transform: 'translateY(-3px) scale(1.05)',
//   },
//   '&:focus-visible': {
//     outline: `3px solid ${alpha(theme.palette.secondary.light, 0.5)}`,
//     outlineOffset: 3,
//   },
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     width: 0,
//     height: 0,
//     background: alpha(theme.palette.common.white, 0.2),
//     borderRadius: '50%',
//     transform: 'translate(-50%, -50%)',
//     transition: 'width 0.6s, height 0.6s',
//   },
//   '&:active::before': {
//     width: '300px',
//     height: '300px',
//   },
// }));

// const StreakChip = styled(Chip)(({ theme }) => ({
//   background: `linear-gradient(135deg, #ff6b6b, #ee5a24, #ff6b6b)`,
//   backgroundSize: '200% 200%',
//   color: theme.palette.common.white,
//   fontWeight: 700,
//   animation: `${pulse} 3s ease-in-out infinite, ${gradientShift} 4s ease-in-out infinite`,
//   boxShadow: `0 10px 30px ${alpha('#ff6b6b', 0.5)}`,
//   fontSize: '1.1rem',
//   padding: theme.spacing(1.5, 3),
//   borderRadius: 25,
// }));

// const StatsContainer = styled(Grid)(({ theme }) => ({
//   animation: `${fadeInUp} 1s ease-out 1s both`,
// }));

// const EnhancedMessageBox = styled(Paper)(({ theme }) => ({
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.background.paper, 0.95)} 0%, 
//     ${alpha(theme.palette.background.default, 0.9)} 100%)`,
//   backdropFilter: 'blur(20px)',
//   borderRadius: theme.spacing(3),
//   padding: theme.spacing(6),
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//   boxShadow: `0 20px 60px ${alpha(theme.palette.primary.main, 0.15)}`,
//   maxWidth: 1000,
//   margin: '3rem auto',
//   textAlign: 'center',
//   position: 'relative',
//   overflow: 'hidden',
//   animation: `${fadeInUp} 1s ease-out`,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: '3px',
//     background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
//     backgroundSize: '200% 100%',
//     animation: `${shimmer} 2s ease-in-out infinite`,
//   },
// }));

// const FeaturesSection = styled(Container)(({ theme }) => ({
//   padding: theme.spacing(8, 0),
//   animation: `${fadeInUp} 1s ease-out`,
// }));

// const FeatureCard = styled(Card)(({ theme }) => ({
//   height: '100%',
//   background: `linear-gradient(135deg, 
//     ${alpha(theme.palette.background.paper, 0.95)} 0%, 
//     ${alpha(theme.palette.background.default, 0.9)} 100%)`,
//   backdropFilter: 'blur(20px)',
//   borderRadius: theme.spacing(3),
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//   boxShadow: `0 15px 35px ${alpha(theme.palette.common.black, 0.08)}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   overflow: 'hidden',
//   position: 'relative',
//   animation: `${fadeInUp} 0.8s ease-out`,
//   '&:nth-of-type(even)': {
//     animationDelay: '0.2s',
//   },
//   '&:nth-of-type(3n)': {
//     animationDelay: '0.4s',
//   },
//   '&:hover': {
//     transform: 'translateY(-10px) scale(1.02)',
//     boxShadow: `0 25px 60px ${alpha(theme.palette.primary.main, 0.2)}`,
//     '& .feature-icon': {
//       transform: 'scale(1.1) rotate(5deg)',
//     },
//     '& .learn-more': {
//       transform: 'translateX(5px)',
//     },
//   },
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: '2px',
//     background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, transparent)`,
//     opacity: 0,
//     transition: 'opacity 0.3s ease',
//   },
//   '&:hover::before': {
//     opacity: 1,
//   },
// }));

// const AIChatButton = styled(Fab)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//   color: theme.palette.common.white,
//   width: 80,
//   height: 80,
//   boxShadow: `0 15px 40px ${alpha(theme.palette.primary.main, 0.4)}`,
//   animation: `${float} 3s ease-in-out infinite`,
//   '&:hover': {
//     background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
//     transform: 'scale(1.15)',
//     boxShadow: `0 20px 60px ${alpha(theme.palette.primary.main, 0.6)}`,
//   },
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   outline: 'none',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: -2,
//     left: -2,
//     right: -2,
//     bottom: -2,
//     background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//     borderRadius: '50%',
//     zIndex: -1,
//     opacity: 0,
//     transition: 'opacity 0.3s ease',
//   },
//   '&:hover::before': {
//     opacity: 0.3,
//   },
// }));

// const SpeechBubble = styled(motion.div)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${alpha(theme.palette.primary.light, 0.1)})`,
//   color: theme.palette.primary.main,
//   padding: '16px 24px',
//   borderRadius: 25,
//   boxShadow: `0 15px 40px ${alpha(theme.palette.primary.main, 0.2)}`,
//   marginBottom: 20,
//   fontSize: 16,
//   fontWeight: 600,
//   position: 'relative',
//   backdropFilter: 'blur(20px)',
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//   userSelect: 'none',
//   maxWidth: 280,
//   animation: `${slideInRight} 0.6s ease-out`,
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     bottom: -12,
//     left: '50%',
//     transform: 'translateX(-50%)',
//     width: 0,
//     height: 0,
//     borderLeft: '12px solid transparent',
//     borderRight: '12px solid transparent',
//     borderTop: `14px solid ${theme.palette.background.paper}`,
//   },
// }));

// const FloatingElement = styled(Box)(({ theme, delay = 0 }) => ({
//   position: 'absolute',
//   borderRadius: '50%',
//   background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)}, ${alpha(theme.palette.secondary.main, 0.1)})`,
//   animation: `${float} ${3 + Math.random() * 2}s ease-in-out infinite`,
//   animationDelay: `${delay}s`,
//   zIndex: 0,
// }));

// const CTASection = styled(Container)(({ theme }) => ({
//   padding: theme.spacing(8, 0),
//   animation: `${fadeInUp} 1s ease-out`,
// }));

// const Home = () => {
//   const [message, setMessage] = useState('');
//   const [studyStreak, setStudyStreak] = useState(0);
//   const [showAIBubble, setShowAIBubble] = useState(false);
//   const { token } = useContext(AuthContext);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const username = localStorage.getItem('username');

//   const features = [
//     {
//       icon: <SchoolIcon fontSize="large" />,
//       title: 'Smart Learning',
//       description: 'AI-powered study materials and personalized learning paths tailored to your needs.',
//       color: theme.palette.primary.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`
//     },
//     {
//       icon: <GroupIcon fontSize="large" />,
//       title: 'Collaborative Study',
//       description: 'Connect with peers, join study groups, and learn together in real-time.',
//       color: theme.palette.secondary.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.secondary.light}, ${theme.palette.secondary.main})`
//     },
//     {
//       icon: <AssignmentIcon fontSize="large" />,
//       title: 'Progress Tracking',
//       description: 'Monitor your academic progress with detailed analytics and insights.',
//       color: theme.palette.success.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.success.light}, ${theme.palette.success.main})`
//     },
//     {
//       icon: <ChatIcon fontSize="large" />,
//       title: 'AI Assistant',
//       description: 'Get instant help with your studies from our intelligent chatbot, available 24/7.',
//       color: theme.palette.warning.main,
//       bgGradient: `linear-gradient(135deg, ${theme.palette.warning.light}, ${theme.palette.warning.main})`
//     }
//   ];

//   const stats = [
//     { number: '10K+', label: 'Active Students' },
//     { number: '95%', label: 'Success Rate' },
//     { number: '24/7', label: 'AI Support' },
//     { number: '500+', label: 'Study Resources' }
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowAIBubble(true);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API_URL}/`)
//       .then((response) => {
//         setMessage(response.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching data from backend:', error);
//       });
//   }, []);

//   useEffect(() => {
//     const fetchStreak = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/study-streak`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setStudyStreak(response.data.studyStreak);
//       } catch (error) {
//         console.error('Error fetching study streak:', error);
//       }
//     };
//     if (token) {
//       fetchStreak();
//     }
//   }, [token]);

//   return (
//     <>
//       <CustomCursor />
//       <Box
//         sx={{
//           minHeight: '100vh',
//           background: `linear-gradient(135deg, 
//             ${theme.palette.background.default} 0%, 
//             ${alpha(theme.palette.primary.light, 0.05)} 50%,
//             ${alpha(theme.palette.secondary.light, 0.05)} 100%)`,
//           position: 'relative',
//           overflow: 'hidden',
//           width: '100%',
//         }}
//       >
//         {/* Enhanced Floating Elements */}
//         {[...Array(5)].map((_, i) => (
//           <FloatingElement
//             key={i}
//             delay={i * 0.5}
//             sx={{
//               width: 60 + i * 20,
//               height: 60 + i * 20,
//               top: `${10 + i * 15}%`,
//               left: `${5 + i * 20}%`,
//               right: i % 2 === 0 ? `${5 + i * 15}%` : 'auto',
//             }}
//           />
//         ))}

//         <Box sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
//           {/* Full Width Hero Section */}
//           <FullWidthHeroContainer>
//             <BackgroundImage sx={{ backgroundImage: `url(${backgroundImage})` }} />
//             <GradientOverlay />

//             <HeroContent maxWidth="lg">
//               <Chip
//                 icon={<AutoAwesomeIcon />}
//                 label="Welcome to the Future of Learning"
//                 sx={{
//                   mb: 4,
//                   background: alpha(theme.palette.common.white, 0.2),
//                   color: 'white',
//                   backdropFilter: 'blur(10px)',
//                   fontSize: '1rem',
//                   fontWeight: 600,
//                   py: 1,
//                   px: 3,
//                   animation: `${fadeInUp} 1s ease-out`,
//                 }}
//               />

//               <WelcomeText variant="h3">
//                 {username ? `Welcome back, ${username}! 👋` : 'Welcome! Please log in.'}
//               </WelcomeText>

//               <MainTitle variant="h1">
//                 SSPACE WARDHA
//                 <br />
//                 <HighlightText>Smart Dashboard</HighlightText>
//               </MainTitle>

//               <Description variant="h6">
//                 Transform your academic journey with AI-powered learning tools, collaborative features, 
//                 and intelligent progress tracking designed for the modern student.
//               </Description>

//               <ButtonContainer>
//                 <ExploreButton
//                   size="large"
//                   onClick={() => navigate('/dashboard')}
//                   startIcon={<RocketLaunchIcon />}
//                   aria-label="Explore Dashboard"
//                 >
//                   Launch Dashboard
//                 </ExploreButton>

//                 {token && (
//                   <StreakChip
//                     icon={<TrendingUpIcon />}
//                     label={`${studyStreak} day streak 🔥`}
//                     variant="filled"
//                     aria-label="Study streak"
//                   />
//                 )}
//               </ButtonContainer>

//               {/* Stats Section */}
//               <StatsContainer container spacing={4}>
//                 {stats.map((stat, index) => (
//                   <Grid item xs={6} md={3} key={index}>
//                     <Box sx={{ textAlign: 'center' }}>
//                       <Typography
//                         variant="h3"
//                         sx={{
//                           fontWeight: 900,
//                           color: 'white',
//                           mb: 1,
//                           fontSize: { xs: '2rem', md: '2.5rem' },
//                           textShadow: '0 4px 12px rgba(0,0,0,0.4)',
//                         }}
//                       >
//                         {stat.number}
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           color: alpha(theme.palette.common.white, 0.9),
//                           fontWeight: 500,
//                           fontSize: '1.1rem',
//                         }}
//                       >
//                         {stat.label}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 ))}
//               </StatsContainer>
//             </HeroContent>
//           </FullWidthHeroContainer>

//           {/* Enhanced Message Box */}
//           <Container maxWidth="lg">
//             <EnhancedMessageBox elevation={0}>
//               <Typography
//                 variant="h5"
//                 sx={{
//                   color: 'text.primary',
//                   fontWeight: 600,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: 2,
//                   mb: 2,
//                 }}
//               >
//                 <SchoolIcon color="primary" sx={{ fontSize: 32 }} />
//                 {message || 'Loading...'}
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: 'text.secondary',
//                   maxWidth: 600,
//                   mx: 'auto',
//                 }}
//               >
//                 Experience the next generation of academic excellence with our comprehensive platform.
//               </Typography>
//             </EnhancedMessageBox>
//           </Container>

//           {/* Enhanced Features Section */}
//           <FeaturesSection maxWidth="lg">
//             <Box sx={{ textAlign: 'center', mb: 6 }}>
//               <Chip
//                 icon={<StarIcon />}
//                 label="Powerful Features"
//                 sx={{
//                   mb: 3,
//                   background: theme.palette.primary.main,
//                   color: 'white',
//                   fontSize: '1rem',
//                   py: 1,
//                   px: 3,
//                 }}
//               />
//               <Typography
//                 variant="h2"
//                 sx={{
//                   fontWeight: 900,
//                   color: 'text.primary',
//                   mb: 3,
//                   fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 }}
//               >
//                 Everything You Need to{' '}
//                 <Box
//                   component="span"
//                   sx={{
//                     background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                     WebkitBackgroundClip: 'text',
//                     WebkitTextFillColor: 'transparent',
//                   }}
//                 >
//                   Excel
//                 </Box>
//               </Typography>
//             </Box>

//             <Grid container spacing={4}>
//               {features.map((feature, index) => (
//                 <Grid item xs={12} sm={6} lg={3} key={index}>
//                   <FeatureCard elevation={0}>
//                     <CardContent sx={{ p: 4, height: '100%' }}>
//                       <Avatar
//                         className="feature-icon"
//                         sx={{
//                           width: 80,
//                           height: 80,
//                           mb: 3,
//                           background: feature.bgGradient,
//                           boxShadow: `0 15px 35px ${alpha(feature.color, 0.3)}`,
//                           transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//                         }}
//                       >
//                         {feature.icon}
//                       </Avatar>
                      
//                       <Typography
//                         variant="h5"
//                         sx={{
//                           fontWeight: 700,
//                           mb: 2,
//                           color: 'text.primary',
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>
                      
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           color: 'text.secondary',
//                           lineHeight: 1.7,
//                           mb: 3,
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
                      
//                       <Box
//                         className="learn-more"
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           color: feature.color,
//                           fontWeight: 600,
//                           fontSize: '1rem',
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             color: theme.palette.text.primary,
//                           }
//                         }}
//                       >
//                         Explore Feature
//                         <ArrowForwardIcon sx={{ ml: 1, fontSize: '1.2rem' }} />
//                       </Box>
//                     </CardContent>
//                   </FeatureCard>
//                 </Grid>
//               ))}
//             </Grid>
//           </FeaturesSection>

//           {/* Call to Action Section */}
//           <CTASection maxWidth="lg">
//             <Paper
//               elevation={0}
//               sx={{
//                 background: `linear-gradient(135deg, 
//                   ${alpha(theme.palette.primary.main, 0.08)} 0%, 
//                   ${alpha(theme.palette.secondary.main, 0.08)} 100%)`,
//                 backdropFilter: 'blur(20px)',
//                 borderRadius: 4,
//                 p: { xs: 4, md: 8 },
//                 textAlign: 'center',
//                 border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//                 position: 'relative',
//                 overflow: 'hidden',
//                 animation: `${fadeInUp} 1s ease-out`,
//                 '&::before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   height: '100%',
//                   background: `radial-gradient(circle at 30% 20%, ${alpha(theme.palette.primary.main, 0.1)} 0%, transparent 50%)`,
//                   zIndex: 0,
//                 },
//               }}
//             >
//               <Box sx={{ position: 'relative', zIndex: 1 }}>
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 900,
//                     color: 'text.primary',
//                     mb: 3,
//                     fontSize: { xs: '2.5rem', md: '3.5rem' },
//                   }}
//                 >
//                   Ready to{' '}
//                   <Box
//                     component="span"
//                     sx={{
//                       background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent',
//                     }}
//                   >
//                     Transform
//                   </Box>{' '}
//                   Your Learning?
//                 </Typography>
                
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     color: 'text.secondary',
//                     mb: 5,
//                     maxWidth: 700,
//                     mx: 'auto',
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   Join thousands of students who have already discovered the power of smart academic management. 
//                   Start your journey towards academic excellence today.
//                 </Typography>
                
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     gap: 3,
//                     justifyContent: 'center',
//                     flexDirection: { xs: 'column', sm: 'row' },
//                     mb: 4,
//                   }}
//                 >
//                   <Button
//                     variant="contained"
//                     size="large"
//                     endIcon={<ArrowForwardIcon />}
//                     onClick={() => navigate('/login')}
//                     sx={{
//                       px: 5,
//                       py: 2,
//                       fontSize: '1.2rem',
//                       fontWeight: 700,
//                       borderRadius: 50,
//                       background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                       boxShadow: `0 15px 35px ${alpha(theme.palette.primary.main, 0.3)}`,
//                       transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//                       '&:hover': {
//                         transform: 'translateY(-3px)',
//                         boxShadow: `0 20px 50px ${alpha(theme.palette.primary.main, 0.4)}`,
//                       },
//                     }}
//                   >
//                     Get Started Free
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     size="large"
//                     startIcon={<PlayArrowIcon />}
//                     sx={{
//                       px: 5,
//                       py: 2,
//                       fontSize: '1.2rem',
//                       fontWeight: 700,
//                       borderRadius: 50,
//                       borderColor: theme.palette.primary.main,
//                       color: theme.palette.primary.main,
//                       borderWidth: 2,
//                       transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//                       '&:hover': {
//                         borderWidth: 2,
//                         background: alpha(theme.palette.primary.main, 0.05),
//                         transform: 'translateY(-2px)',
//                       },
//                     }}
//                   >
//                     Watch Demo
//                   </Button>
//                 </Box>
                
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: 'text.secondary',
//                     fontSize: '1rem',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: 1,
//                     flexWrap: 'wrap',
//                   }}
//                 >
//                   <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
//                   No credit card required • Free forever • Premium features available
//                 </Typography>
//               </Box>
//             </Paper>
//           </CTASection>

//           <HomeContent />
//           <Footer />
//         </Box>

//         {/* Enhanced AI Chat Button */}
//         <AnimatePresence>
//           {showAIBubble && (
//             <motion.div
//               initial={{ opacity: 0, scale: 0, y: 100 }}
//               animate={{ opacity: 1, scale: 1, y: 0 }}
//               exit={{ opacity: 0, scale: 0, y: 100 }}
//               transition={{ 
//                 duration: 0.6, 
//                 type: "spring", 
//                 stiffness: 200, 
//                 damping: 20 
//               }}
//               style={{
//                 position: 'fixed',
//                 bottom: isMobile ? 20 : 30,
//                 right: isMobile ? 20 : 30,
//                 zIndex: 1300,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 gap: 12,
//               }}
//             >
//               <SpeechBubble
//                 initial={{ opacity: 0, y: -20, scale: 0.8 }}
//                 animate={{ opacity: 1, y: 0, scale: 1 }}
//                 transition={{ duration: 0.5, delay: 0.3 }}
//                 whileHover={{ scale: 1.05 }}
//                 role="tooltip"
//                 aria-live="polite"
//               >
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Typography variant="body2" sx={{ fontWeight: 700 }}>
//                     Hi, I'm SSPACE Bot! 🤖
//                   </Typography>
//                 </Box>
//                 <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                   Click to start chatting with me!
//                 </Typography>
//               </SpeechBubble>

//               <Tooltip title="Open AI Chatbot" arrow placement="left">
//                 <motion.div
//                   animate={{
//                     scale: [1, 1.1, 1],
//                     rotate: [0, 5, -5, 0],
//                   }}
//                   transition={{
//                     repeat: Infinity,
//                     duration: 4,
//                     ease: 'easeInOut',
//                   }}
//                   whileHover={{ scale: 1.2 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <AIChatButton 
//                     onClick={() => navigate('/ai-chatbot')} 
//                     aria-label="AI Chatbot"
//                   >
//                     <SmartToyIcon sx={{ fontSize: 36 }} />
//                   </AIChatButton>
//                 </motion.div>
//               </Tooltip>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </Box>
//     </>
//   );
// };

// export default Home;


// src/pages/Home.js
import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import {
  Container,
  Box,
  Typography,
  Button,
  Fab,
  Chip,
  useTheme,
  useMediaQuery,
  Tooltip,
  Grid,
  Card,
  CardContent,
  Avatar,
  Paper,
  alpha,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SchoolIcon from '@mui/icons-material/School';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import StarIcon from '@mui/icons-material/Star';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import GroupIcon from '@mui/icons-material/Group';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import backgroundImage from '../Images/clg.png';
import { AuthContext } from '../contexts/AuthContext';
import Footer from '../components/Footer';
import HomeContent from '../components/HomeContent';
import { motion, AnimatePresence } from 'framer-motion';
import { styled, keyframes } from '@mui/material/styles';

// Modern, clean animations
const fadeInUp = keyframes`
  from { 
    transform: translateY(30px); 
    opacity: 0; 
  }
  to { 
    transform: translateY(0); 
    opacity: 1; 
  }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
`;

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

// Styled Components with modern, clean design
const HeroSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    filter: 'brightness(1.1) contrast(1.1)',
    zIndex: -2,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(135deg, 
      rgba(13, 27, 42, 0.4) 0%, 
      rgba(27, 39, 53, 0.3) 50%,
      rgba(13, 27, 42, 0.4) 100%)`,
    zIndex: -1,
  },
}));

const HeroContent = styled(Container)(({ theme }) => ({
  position: 'relative',
  zIndex: 10,
  textAlign: 'center',
  color: 'white',
  padding: theme.spacing(4),
  animation: `${fadeInUp} 1s ease-out`,
  background: 'rgba(0, 0, 0, 0.3)',
  backdropFilter: 'blur(10px)',
  borderRadius: 24,
  border: '1px solid rgba(255, 255, 255, 0.1)',
}));

const GradientText = styled(Typography)(({ theme }) => ({
  background: 'linear-gradient(135deg, #64B5F6 0%, #42A5F5 50%, #1E88E5 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  fontWeight: 800,
}));

const GlowButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1E88E5 0%, #1976D2 100%)',
  color: 'white',
  padding: theme.spacing(1.5, 4),
  borderRadius: 50,
  fontSize: '1.1rem',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 8px 32px rgba(30, 136, 229, 0.3)',
  border: 'none',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 12px 40px rgba(30, 136, 229, 0.4)',
    background: 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    transition: 'left 0.5s ease',
  },
  '&:hover::before': {
    left: '100%',
  },
}));

const OutlineButton = styled(Button)(({ theme }) => ({
  border: '2px solid rgba(255, 255, 255, 0.3)',
  color: 'white',
  padding: theme.spacing(1.5, 4),
  borderRadius: 50,
  fontSize: '1.1rem',
  fontWeight: 600,
  textTransform: 'none',
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  transition: 'all 0.3s ease',
  '&:hover': {
    border: '2px solid rgba(255, 255, 255, 0.5)',
    background: 'rgba(255, 255, 255, 0.2)',
    transform: 'translateY(-2px)',
  },
}));

const ModernCard = styled(Card)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(20px)',
  borderRadius: 24,
  border: '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  overflow: 'hidden',
  position: 'relative',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 4,
    background: 'linear-gradient(135deg, #1E88E5, #42A5F5)',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  '&:hover::before': {
    opacity: 1,
  },
}));

const StatsCard = styled(Box)(({ theme }) => ({
  background: 'rgba(0, 0, 0, 0.4)',
  backdropFilter: 'blur(15px)',
  borderRadius: 16,
  padding: theme.spacing(3),
  border: '1px solid rgba(255, 255, 255, 0.2)',
  textAlign: 'center',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.5)',
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  },
}));

const FloatingChatButton = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  right: 24,
  background: 'linear-gradient(135deg, #1E88E5, #42A5F5)',
  color: 'white',
  width: 64,
  height: 64,
  zIndex: 1000,
  boxShadow: '0 8px 32px rgba(30, 136, 229, 0.3)',
  animation: `${float} 3s ease-in-out infinite`,
  '&:hover': {
    background: 'linear-gradient(135deg, #1976D2, #1E88E5)',
    transform: 'scale(1.1)',
    boxShadow: '0 12px 40px rgba(30, 136, 229, 0.4)',
  },
}));

const ChatBubble = styled(motion.div)(({ theme }) => ({
  position: 'fixed',
  bottom: 100,
  right: 24,
  background: 'white',
  borderRadius: 20,
  padding: '16px 20px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
  maxWidth: 280,
  zIndex: 999,
  border: '1px solid rgba(0, 0, 0, 0.1)',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -8,
    right: 24,
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderTop: '8px solid white',
  },
}));

const SectionContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(8, 0),
  position: 'relative',
}));

const Home = () => {
  const [message, setMessage] = useState('');
  const [studyStreak, setStudyStreak] = useState(0);
  const [showChatBubble, setShowChatBubble] = useState(false);
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const username = localStorage.getItem('username');

  const features = [
    {
      icon: <GroupIcon sx={{ fontSize: 40, color: '#43A047' }} />,
      title: 'Collaborative Study',
      description: 'Connect with peers, join study groups, and learn together in real-time.',
      gradient: 'linear-gradient(135deg, #E8F5E8 0%, #C8E6C9 100%)',
    },
    {
      icon: <AssignmentIcon sx={{ fontSize: 40, color: '#FB8C00' }} />,
      title: 'Progress Tracking',
      description: 'Monitor your academic progress with detailed analytics and insights.',
      gradient: 'linear-gradient(135deg, #FFF3E0 0%, #FFCC80 100%)',
    },
    {
      icon: <ChatIcon sx={{ fontSize: 40, color: '#E91E63' }} />,
      title: 'AI Assistant',
      description: 'Get instant help with studies from our intelligent chatbot, available 24/7.',
      gradient: 'linear-gradient(135deg, #FCE4EC 0%, #F8BBD9 100%)',
    },
  ];

  const stats = [
    { number: '24/7', label: 'AI Support' },
    { number: '500+', label: 'Study Resources' },
  ];

  useEffect(() => {
    const timer = setTimeout(() => setShowChatBubble(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/`)
      .then((response) => setMessage(response.data))
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  useEffect(() => {
    const fetchStreak = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/study-streak`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStudyStreak(response.data.studyStreak);
      } catch (error) {
        console.error('Error fetching study streak:', error);
      }
    };
    if (token) fetchStreak();
  }, [token]);

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      {/* Hero Section */}
      <HeroSection>
        <HeroContent maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Chip
              icon={<AutoAwesomeIcon />}
              label="Welcome to the Future of Learning"
              sx={{
                mb: 3,
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                fontSize: '1rem',
                py: 1,
                px: 2,
              }}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                opacity: 0.9,
                fontWeight: 500,
              }}
            >
              {username ? `Welcome back, ${username}! 👋` : 'Welcome! Please log in.'}
            </Typography>

            <Typography
              variant="h1"
              sx={{
                fontWeight: 900,
                fontSize: { xs: '2.5rem', md: '4rem', lg: '5rem' },
                lineHeight: 1.1,
                mb: 3,
              }}
            >
              SSPACE WARDHA
              <br />
              <GradientText variant="h1" sx={{ fontSize: { xs: '2rem', md: '3rem', lg: '4rem' } }}>
                Smart Dashboard
              </GradientText>
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 5,
                opacity: 0.9,
                maxWidth: 600,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
              }}
            >
              Transform your academic journey with AI-powered learning tools, collaborative features,
              and intelligent progress tracking.
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', mb: 6 }}>
              <GlowButton
                size="large"
                startIcon={<RocketLaunchIcon />}
                onClick={() => navigate('/dashboard')}
              >
                Launch Dashboard
              </GlowButton>

              <OutlineButton
                size="large"
                startIcon={<PlayArrowIcon />}
              >
                Watch Demo
              </OutlineButton>

              {token && (
                <Chip
                  icon={<TrendingUpIcon />}
                  label={`${studyStreak} day streak 🔥`}
                  sx={{
                    background: 'linear-gradient(135deg, #FF6B6B, #EE5A24)',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '1rem',
                    py: 1.5,
                    px: 2,
                  }}
                />
              )}
            </Box>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Grid container spacing={3} sx={{ mt: 4, justifyContent: 'center' }}>
              {stats.map((stat, index) => (
                <Grid item xs={6} md={3} key={index}>
                  <StatsCard>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 900,
                        color: 'white',
                        mb: 1,
                        fontSize: { xs: '2rem', md: '2.5rem' },
                      }}
                    >
                      {stat.number}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontWeight: 500,
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </StatsCard>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </HeroContent>
      </HeroSection>

      {/* Welcome Message */}
      <SectionContainer maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%)',
            backdropFilter: 'blur(20px)',
            borderRadius: 3,
            p: 4,
            textAlign: 'center',
            border: '1px solid rgba(0, 0, 0, 0.05)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: 'text.primary',
              fontWeight: 700,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
            }}
          >
            <SchoolIcon color="primary" sx={{ fontSize: 36 }} />
            {message || 'Loading...'}
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
            Experience the next generation of academic excellence with our comprehensive platform.
          </Typography>
        </Paper>
      </SectionContainer>

      {/* Features Section */}
      <SectionContainer maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Chip
            icon={<StarIcon />}
            label="Powerful Features"
            sx={{
              mb: 3,
              background: 'linear-gradient(135deg, #1E88E5, #42A5F5)',
              color: 'white',
              fontSize: '1rem',
              py: 1,
              px: 2,
            }}
          />
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              color: 'text.primary',
              mb: 3,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
            }}
          >
            Everything You Need to{' '}
            <GradientText component="span" variant="h2" sx={{ fontSize: 'inherit' }}>
              Excel
            </GradientText>
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} lg={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <ModernCard>
                  <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Avatar
                      sx={{
                        width: 80,
                        height: 80,
                        mb: 3,
                        mx: 'auto',
                        background: feature.gradient,
                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      {feature.icon}
                    </Avatar>
                    
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        mb: 2,
                        color: 'text.primary',
                      }}
                    >
                      {feature.title}
                    </Typography>
                    
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'text.secondary',
                        lineHeight: 1.7,
                        mb: 3,
                      }}
                    >
                      {feature.description}
                    </Typography>
                    
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main',
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          color: 'primary.dark',
                          transform: 'translateX(4px)',
                        }
                      }}
                    >
                      Learn More
                      <ArrowForwardIcon sx={{ ml: 1, fontSize: 20 }} />
                    </Box>
                  </CardContent>
                </ModernCard>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </SectionContainer>

      {/* CTA Section */}
      <SectionContainer maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            background: 'linear-gradient(135deg, rgba(30, 136, 229, 0.05) 0%, rgba(66, 165, 245, 0.08) 100%)',
            borderRadius: 4,
            p: { xs: 4, md: 8 },
            textAlign: 'center',
            border: '1px solid rgba(30, 136, 229, 0.1)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              color: 'text.primary',
              mb: 3,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
            }}
          >
            Ready to{' '}
            <GradientText component="span" variant="h2" sx={{ fontSize: 'inherit' }}>
              Transform
            </GradientText>{' '}
            Your Learning?
          </Typography>
          
          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              mb: 5,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Join thousands of students who have discovered the power of smart academic management.
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              justifyContent: 'center',
              flexDirection: { xs: 'column', sm: 'row' },
              mb: 4,
            }}
          >
            <GlowButton
              size="large"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate('/login')}
              sx={{ px: 5, py: 2 }}
            >
              Get Started Free
            </GlowButton>
            <Button
              variant="outlined"
              size="large"
              startIcon={<PlayArrowIcon />}
              sx={{
                px: 5,
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: 50,
                borderColor: 'primary.main',
                color: 'primary.main',
                borderWidth: 2,
                '&:hover': {
                  borderWidth: 2,
                  background: alpha(theme.palette.primary.main, 0.05),
                },
              }}
            >
              Watch Demo
            </Button>
          </Box>
        </Paper>
      </SectionContainer>

      <HomeContent />
      <Footer />

      {/* Floating Chat Bubble */}
      <AnimatePresence>
        {showChatBubble && (
          <ChatBubble
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ duration: 0.5 }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
                  Hi, I'm SSPACE Bot! 🤖
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Need help with your studies? Click to chat!
                </Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => setShowChatBubble(false)}
                sx={{ color: 'text.secondary' }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </ChatBubble>
        )}
      </AnimatePresence>

      {/* Floating Chat Button */}
      <Tooltip title="Open AI Chatbot" arrow placement="left">
        <FloatingChatButton onClick={() => navigate('/ai-chatbot')}>
          <SmartToyIcon sx={{ fontSize: 28 }} />
        </FloatingChatButton>
      </Tooltip>
    </Box>
  );
};

export default Home;